import { useEffect, useRef, useState } from "react";
import { useDispatch } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { ApiCall } from "../CommonComponents/CustomHooks";
import { AutoCompleteBoxNew, FormButton } from "../CommonComponents/InputBox";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { Table } from "../CommonComponents/Table";
import { handleDownloadExcel } from "../CommonComponents/ExportData";

const Dashboard = () => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [StatusType, setStatusType] = useState('');
    const [result, setResult] = useState({})
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [isLoading, setIsLoading] = useState(false)
    const [formData, setFormData] = useState({
        clientCode: 'C1001 : Tripura Health & Family Welfare',
        eventCode: '',
    });

    const [ProgressDetaits, setProgressDetaits] = useState([]);

    const GetProgessDetailsData = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Dashboard/GetDashboardCount`, { ...formData })
        await dispatch(setSubLoading(false))
        if (data.status === "SUCCESS") {
            await setProgressDetaits(data.progressList)
        } else {
            await NotificationSound(data.status, data.message, data.focus, inputrefs)
        }
    };

    const GetModelData = async (CurrentPage, type) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            Type: 'S',
            PageIndex: PageIndex.toString(),
        }
        await setResult({})
        await setStatusType(type)
        await setIsLoading(true)
        await dispatch(setSubLoading(true))
        let res = await ApiCall(`/api/Report/CandidateReport`, { "Client": formData.clientCode, "Event": formData.eventCode, "StatusType": type, ...data })
        await setIsLoading(false)
        if (res.Status === "SUCCESS") {
            await setResult({ ...res })
            await setIsModalOpen(true)
        }
        if (res.Status === "ERROR") {
            await setResult({ ...res })
        }
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
        await dispatch(setSubLoading(false))
    }
    let ExportRequest = {
        ...formData,
        StatusType: StatusType,
        Type: 'E',
        PageIndex: '1'
    }



    const handleChange1 = (event, value) => {
        GetModelData(value, StatusType);
    };

    useEffect(() => {
        GetProgessDetailsData();
        document.title = 'Dashboard';
        inputrefs.current['txtEvent'].focus();
    }, []);

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Dashboard'} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <AutoCompleteBoxNew
                                id="txtClientCode"
                                label='Client Code'
                                required={true}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEvent'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                maxLength='10'
                                placeholder='Client Code'
                                name='ClientCode'
                                value={formData.clientCode || ''}
                                onChange={(e) => setFormData({ ...formData, clientCode: e.target.value })}
                                autocompleteType='GetClientData'
                            />
                            <AutoCompleteBoxNew
                                id="txtEvent"
                                label='Event Code'
                                required={true}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                maxLength='10'
                                placeholder='Event Code'
                                name='EventCode'
                                value={formData.eventCode || ''}
                                autocompleteType='GetEventData'
                                contextKey={formData.clientCode}
                                onChange={async (eventCode, newInputValue) => {
                                    newInputValue = newInputValue || ''
                                    if (eventCode.type !== 'keydown') {
                                        setFormData({ ...formData, eventCode: newInputValue })
                                    }
                                }}
                            />
                            <div className='col-sm-3 mt-3'>
                                <FormButton
                                    id={'btnSub'}
                                    save={false}
                                    search={true}
                                    handleSearch={GetProgessDetailsData}
                                    inputrefs={inputrefs}
                                    Export={false}
                                    Reset={false}
                                />
                            </div>
                        </div>
                    </div>
                    {ProgressDetaits && ProgressDetaits.length > 0 &&
                        <div className='container-fluid mt-3'>
                            <div className='row mb-2 mx-0 pt-2' style={{
                                borderTop: '2px solid #004196',
                                borderBottom: '.5px solid #dbeaff',
                                borderLeft: '.5px solid #dbeaff',
                                borderRight: '.5px solid #dbeaff',
                                borderRadius: '8px'
                            }}>
                                {ProgressDetaits?.map?.((item, index) =>
                                    <div class="col-md-2 col-sm-4 cntrl-width">
                                        <div class="main-card card border-0" onClick={() => {
                                            if (item?.key) {
                                                const formattedKey = item.key.replace(' ', '').toUpperCase();
                                                GetModelData('1', formattedKey);
                                            }
                                        }}
                                            style={{ "backgroundColor": "rgb(255, 255, 255)", "borderRadius": "5rem", cursor: 'pointer' }} >
                                            <div class="card-header d-flex align-items-center justify-content-between py-1">
                                                <div class="mb-1 py-1 px-1"><div class="m-0" style={{ "fontSize": "12px", "color": item.color || 'black', "fontWeight": "600" }}>{item.key}</div>
                                                    <div class="mt-1" style={{ "fontSize": "16px", "fontWeight": "600", "color": item.color || 'black', "paddingLeft": "5px" }} >{item.value}</div>
                                                </div>
                                                <div class="d-flex align-items-center justify-content-between" style={{ "marginRight": "15px" }} >
                                                    <i class="fa-solid fa-chart-line" style={{ "backgroundColor": "rgb(195, 142, 180)", "height": "35px", "width": "35px", "borderRadius": "50%", "color": "white", "fontSize": "16px", "padding": "9px" }} >
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                </div>
            </div>
            <Modal show={isModalOpen} backdrop="static" /*dialogAs={DragableModal}*/ onHide={() => setIsModalOpen(false)} size="xl">
                <Modal.Header closeButton style={{ background: "var(--last_bg_all)", cursor: 'pointer' }}>
                    <Modal.Title><h5 className="modal-title d-flex" id="exampleModalLabel">
                        {
                            (StatusType === 'DOWNLOADED' && 'Downloaded') ||
                            (StatusType === 'NOTDOWNLOADED' && 'Not Downloaded')
                        }

                    </h5></Modal.Title>
                </Modal.Header >
                <Modal.Body style={{ background: "var(--last_bg_all)", maxHeight: '450px', padding: '8px' }} className='modal-body table-responsive'>
                    <Table
                        PageName={'DealerDashboard'}
                        loading={isLoading}
                        tableData={result}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        Filter={false}
                        onlyFilterPage={true}
                    />
                </Modal.Body>
                <Modal.Footer style={{ background: "var(--last_bg_all)" }}>
                    <button type="button"
                        onClick={() => handleDownloadExcel(`/api/Report/CandidateReport`, ExportRequest, StatusType)}
                        className="btn btn-rounded btn-warning"
                    >
                        <span className=" text-warning me-2">
                            <i className="fa fa-download text-white color-success">
                            </i>
                        </span>Export
                    </button>
                </Modal.Footer>
            </Modal>
        </>

    )
}
export default Dashboard;